import React from 'react'
import Login from '@page-components/Checkout/CheckoutV2/LoyaltyProgram/loyalties/spoonity/SetLoyaltyWalletCode/Login'
import Register from '@page-components/Checkout/CheckoutV2/LoyaltyProgram/loyalties/spoonity/SetLoyaltyWalletCode/Register'
import {useApolloQuery as useQuery} from 'apollo-hooks'
import gql from 'graphql-tag'

import styles from './styles.module.css'

export default function LoyaltyAuth({
  preferences,
  activeLoyalty,
  setPreferences,
  refetchPreferences,
  registerSuccess,
  setRegisterSuccess,
  setLoginSuccess
}) {
  const email = preferences?.user?.email
  const sessionKey = preferences?.loyaltyProgram?.sessionKey
  const activeLoyaltyLabel = activeLoyalty?.label ? activeLoyalty?.label : 'Programa de lealtad'
  const {customerExists} = useQuery({
    query: gql`
      query customerExistsLoyaltyAuth($customer: String) {
        customerExists(customer: $customer)
      }
    `,
    variables: {customer: email},
    omit: !email,
    fetchPolicy: 'network-only'
  })

  if (customerExists) {
    setRegisterSuccess(true)
  }
  if (sessionKey) {
    setLoginSuccess(true)
    return null
  }

  if (!registerSuccess && !customerExists) {
    return (
      <div className={styles.registerContainer}>
        <h1 className={styles.h1Text}>Bienvenido a {activeLoyaltyLabel}</h1>
        <p className={styles.pText}>Ingresá a tu cuenta y disfrutá de ser {activeLoyaltyLabel}</p>
        <Register
          preferences={preferences}
          setRegisterSuccess={setRegisterSuccess}
          activeLoyalty={activeLoyalty}
          refetchPreferences={refetchPreferences}
        />
      </div>
    )
  }

  return (
    <div className={styles.loginContainer}>
      <Login
        preferences={preferences}
        setPreferences={setPreferences}
        activeLoyalty={activeLoyalty}
      />
    </div>
  )
}
